import styled from '@emotion/styled';
import {cssBackgroundSet} from 'src/domains/layouts/webview/components/common/lazyLoadingImage/common/ImagePictureHelpers';
import { ImagesType } from 'src/domains/sportsbook/state/alternativeEventState/AlternativeEventDetailsItemState';
import { withConfig } from 'src/withConfig';

interface BannersType {
    banners: ImagesType;
}

export const PromoBannerAlternativeEvent = withConfig(theme => styled('div', { label: 'PromoBannerAlternativeEvent' })<BannersType>`
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    padding: 0 10px;
    height: 96px;
    margin: 0 10px;
    margin: 5px;
    cursor: pointer;

    ${({ banners }):string => banners.mobile === '' ? 'none' : cssBackgroundSet({
        img: { src: banners.mobile }
    })};

    @media ${theme.star.mediaQuery.tablet} {
        ${({ banners }):string => banners.mobile === '' ? 'none' : cssBackgroundSet({
            img: { src: banners.tablet }
        })};
    }

    @media ${theme.star.mediaQuery.desktop} {
        ${({ banners }):string => banners.mobile === '' ? 'none' : cssBackgroundSet({
            img: { src: banners.tablet }
        })};
    }

    @media ${theme.star.mediaQuery.largeDesktop}{
        ${({ banners }):string => banners.mobile === '' ? 'none' : cssBackgroundSet({
            img: { src: banners.desktop }
        })};
    }
`);

export const PromoBannerAlternativeEventWrapper = withConfig(theme => styled('div', { label: 'PromoBannerAlternativeEventWrapper' })`
    padding: 0 10px;
    @media ${theme.star.mediaQuery.desktop} {
        padding: 0 20px;
    }
`);
